import { useCallback } from "react";
import useSWRMutation from "swr/mutation";
import { useApi } from "../api";
import { CustomError } from "../errors";
import { Screw, SearchScrewsResponse } from "./types/screw";

const screwsUrl = "/modules/beam_reinforcement/screws?limit=400";

export const useBeamReinforcementScrewsApi = () => {
  const api = useApi();

  const getBeamReinforcementScrews = useCallback(
    (signal: AbortSignal) => {
      return useSWRMutation<Screw[], CustomError, string>(screwsUrl, (url) =>
        api
          .get<SearchScrewsResponse>({ url, signal })
          .then((response) =>
            response.items.sort(
              (first, second) =>
                first.screwFamily.diameter - second.screwFamily.diameter || first.length - second.length,
            ),
          ),
      );
    },
    [api],
  );

  return {
    getBeamReinforcementScrews,
  };
};

export default useBeamReinforcementScrewsApi;
